<template>
  <div>
    <div class="list-wrap mg-b-10">
      <div class="list-heard d-flex mg-b-5">
        <div class="d-flex justify-content-center">
          <label class="ckbox mg-b-0 d-inline-block valign-middle">
            <input
              type="checkbox"
              :checked="isAll"
              @change="changeAllCheck($event)"
            />
            <span></span>
          </label>
        </div>
        <div class="d-flex pd-x-5 flex-1">
          <div class="c-7 tx-white">{{ $t("rm.生产单信息") }}</div>
          <div class="c-3 tx-white">{{ $t("rm.结算信息") }}</div>
          <div class="c-2 tx-white">{{ $t("mall.状态") }}</div>
          <div class="c-5 tx-white">{{ $t("rm.生产信息(预计生产时间)") }}</div>
          <div class="c-3">{{ $t("warehouse.日期") }}</div>
          <div class="c-4 tx-white" style="padding-left: 10px !important">
            {{ $t("mall.操作") }}
          </div>
        </div>
      </div>
      <div
        class="list-body d-flex align-items-flex-start mg-b-10"
        style="overflow-x: hidden"
        v-for="(item, index) in items"
        :key="index + item.code"
        :id="item.code"
        :data-supplierid="item.code"
      >
        <div class="d-flex justify-content-center">
          <label class="ckbox mg-b-0">
            <input
              type="checkbox"
              :value="item.code"
              v-model="checkArr"
            /><span></span>
          </label>
        </div>
        <div class="flex-1 pd-x-5">
          <div class="card bd-gray-400 pd-5">
            <!-- 父表 -->
            <div
              class="d-flex flex-row align-items-center justify-content-start"
            >
              <!-- 生产单信息 -->
              <div class="c-7">
                <!-- 生产单号 -->
                <div class="d-flex align-items-center">
                  <span class="mg-r-5">{{ $t("rm.生产单号") }}:</span>
                  <span class="tx-bold tx-white mg-r-5">{{ item.code }}</span>
                  <a
                    v-show="item.code"
                    class="to-clipboard tx-info"
                    href="javascript:;"
                    :data-clipboard-text="item.code"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                  <a
                    class="mg-l-10 tx-gray-300 hover-white-8"
                    v-if="item.orderLog"
                    href="javascript:;"
                    @click="openMOrderLog(item)"
                    @mouseenter="popContact($event, item, 'orderLog')"
                    @mouseleave="popContact($event)"
                    ><i class="icon ion-information-circled"></i
                  ></a>
                </div>
                <!-- 客户 -->
                <div class="d-flex align-items-center" v-if="item.type == 1">
                  <span class="mg-r-5"
                    >{{ $t("offer.客户") }}&nbsp;&nbsp;:</span
                  >
                  <span class="tx-white">{{ item.distributorName }}</span>
                </div>
                <!-- 地址 -->
                <div class="d-flex align-items-center" v-if="item.type == 1">
                  <span class="mg-r-5">{{ $t("mall.地址") }}&nbsp;&nbsp;:</span>
                  <span class="tx-white">{{ item.address }}</span>
                </div>
                <!-- 采购单 -->
                <div class="d-flex align-items-center" v-if="item.type == 1">
                  <span class="mg-r-5">{{ $t("order.采购单号") }}:</span>
                  <span class="tx-bold tx-white mg-r-5">{{
                    item.orderCodes
                  }}</span>
                  <a
                    v-show="item.orderCodes"
                    class="to-clipboard tx-info"
                    href="javascript:;"
                    :data-clipboard-text="item.orderCodes"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </div>
                <!-- 关联采购单 -->
                <template v-if="item.type == 2">
                  <div>
                    <span class="mg-r-5">{{ $t("rm.关联采购单号") }}:</span>
                    <a
                      href="javascript:;"
                      class="purchase-btn"
                      v-if="(item.orderCodes || '').split(',').length > 1"
                      @click="item.moreCode = !item.moreCode"
                    >
                      <i
                        class="fa mg-r-10 tx-gray-300"
                        :class="
                          item.moreCode ? 'fa-minus-square' : 'fa-plus-square'
                        "
                      ></i>
                    </a>
                  </div>
                  <template
                    v-for="(code, i) in (item.orderCodes || '').split(',')"
                  >
                    <div
                      class="d-flex align-items-center"
                      :key="i"
                      v-if="(item.moreCode == false && i == 0) || item.moreCode"
                    >
                      <span class="tx-bold tx-white mg-r-5">{{ code }}</span>
                      <a
                        v-show="code"
                        class="to-clipboard tx-info"
                        href="javascript:;"
                        :data-clipboard-text="code"
                      >
                        <i class="icon ion-clipboard"></i>
                      </a>
                    </div>
                  </template>
                </template>
                <!-- 订单备注 -->
                <div
                  class="d-flex align-items-center tx-gray-600"
                  v-if="item.type == 1 && item.remark && item.remark.length > 0"
                  :title="item.remark"
                >
                  <span class="mg-r-5">{{ $t("order.订单备注") }}:</span>
                  <span
                    class="d-inline-block tx-ellipsis1 tx-orange"
                    style="max-width: 450px; position: relative; top: 5px"
                    >{{ item.remark[0] }}</span
                  >
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="addOrderRemark(item)"
                    >{{ $t("order.更多") }}</a
                  >
                </div>
              </div>
              <!-- 结算信息 -->
              <div class="c-3">
                <!-- 成本价 -->
                <div>
                  <span class="mg-r-5">{{ $t("product.成本价") }}:</span>
                   <span v-if="$store.state.amountStatus != '1'">
                        ******
                    </span>
                  <span v-else class="tx-white">{{
                    item.price ? "￥" + Number(item.price).toFixed(2) : 0
                  }}</span>
                </div>
                <!-- 商品重量 -->
                <div v-if="item.weight > 0">
                  <span class="mg-r-5">{{ $t("product.商品重量：") }}</span>
                  <span class="tx-white"
                    >{{ Number(item.weight).toFixed(2)
                    }}{{ $t("product.克") }}</span
                  >
                </div>
              </div>
              <!-- 状态 -->
              <div class="c-2">
                <!-- 订单状态 -->
                <div class="tx-white">
                  {{ ($parent.mStatus || {})[item.status].name }}
                </div>
                <!-- 发货状态 -->
                <div v-if="item.shipStatus">
                  ({{ shipStatus[item.shipStatus] }})
                </div>
                <!-- 订单类型 -->
                <div class="tx-primary">
                  {{ types[item.type] }}
                </div>
              </div>
              <!-- 生产信息 -->
              <div class="c-5">
                <!-- 预计完成时间 -->
                <div class="d-flex align-items-center">
                  <span class="mg-r-5">{{ $t("rm.预计完成时间") }}:</span>
                  <span class="tx-white mg-r-5">{{
                    item.expectEndTime
                      ? timeFormat_1(item.expectEndTime)
                      : "---"
                  }}</span>
                </div>
                <!-- 剩余生产时间 -->
                <div class="d-flex align-items-center">
                  <span class="mg-r-5">{{ $t("rm.剩余生产时间") }}:</span>
                  <span class="tx-white"
                    >{{ Math.abs(Number(item.productionDuration)) }}
                    {{ $t("order.天") }}</span
                  >
                  <span
                    class="tx-danger"
                    v-if="Number(item.productionDuration) < 0"
                    >{{ $t("rm.（已超时）") }}</span
                  >
                </div>
              </div>
              <!-- 日期 -->
              <div class="c-3">
                <!-- 创建时间 -->
                <div>
                  <span
                    data-toggle="tooltip-primary"
                    data-placement="right"
                    :data-original-title="$t('other.创建时间')"
                    class="tx-white"
                    >{{
                      item.createTime ? timeFormat_1(item.createTime) : "---"
                    }}</span
                  >
                </div>
                <!-- 完成时间 -->
                <div>
                  <span
                    data-toggle="tooltip-primary"
                    data-placement="right"
                    :data-original-title="$t('other.完成时间')"
                    class="tx-white"
                    >{{
                      item.endTime ? timeFormat_1(item.endTime) : "---"
                    }}</span
                  >
                </div>
                <!-- 采购单时间 -->
                <div>
                  <span
                    data-toggle="tooltip-primary"
                    data-placement="right"
                    :data-original-title="$t('rm.采购单时间')"
                    class="tx-white"
                    >{{
                      item.orderCreateTime
                        ? timeFormat_1(item.orderCreateTime)
                        : "---"
                    }}</span
                  >
                </div>
              </div>
              <!-- 操作 -->
              <div
                class="pos-relative c-4"
                style="padding-left: 15px !important"
              >
                <!-- 打印采料单 -->
                <div v-if="isSysRights('Production.takeRawsBill')">
                  <a
                    v-if="item.status != 4"
                    href="javascript:;"
                    @click="printMaterialOrder(item)"
                    class="tx-info tx-12 d-inline-block wd-50p"
                    >{{ $t("rm.打印采料单") }}</a
                  >
                </div>
                <!-- 打印生产单 -->
                <div v-if="isSysRights('Production.getProductionOrder')">
                  <a
                    v-if="item.status != 4"
                    href="javascript:;"
                    class="tx-info tx-normal tx-12"
                    @click="printProductionOrder(item)"
                    >{{ $t("rm.打印生产单") }}
                  </a>
                </div>
                <!-- 开始生产 -->
                <div v-if="isSysRights('Production.startProduction')">
                  <a
                    @click="deliveryOrder(item, false)"
                    v-if="item.status != 3 && item.status != 4"
                    href="javascript:;"
                    class="tx-info tx-12 d-inline-block wd-50p"
                    >{{ $t("rm.开始生产") }}</a
                  >
                </div>
                <!-- 生产完成 -->
                <div v-if="isSysRights('Production.completeProduction')">
                  <a
                    v-if="item.status == 2"
                    class="tx-info tx-12 d-inline-block wd-50p"
                    href="javascript:;"
                    @click="productCompletion(item, false)"
                    >{{ $t("rm.生产完成") }}</a
                  >
                </div>
                <!-- 关闭生产单 -->
                <div
                  v-if="
                    (item.type == 2 || item.type == 3) &&
                    isSysRights('Production.cancelProduction')
                  "
                >
                  <a
                    v-if="item.status == 1 || item.status == 2"
                    class="tx-info tx-12 d-inline-block wd-50p"
                    href="javascript:;"
                    @click="closeProductionOrder(item.id)"
                    >{{ $t("rm.关闭生产单") }}</a
                  >
                </div>
                <!-- 备注 -->
                <div v-if="item.type == 1 && isSysRights('Order.addRemark')">
                  <a
                    class="tx-info tx-12 d-inline-block wd-50p"
                    href="javascript:;"
                    @click="addOrderRemark(item)"
                    >{{ $t("mall.备注") }}</a
                  >
                </div>
              </div>
            </div>
            <!-- 子表 -->
            <div>
              <!-- 商品信息 -->
              <div
                class="d-flex flex-row align-items-center justify-content-start"
              >
                <div class="d-flex align-items-center c-8">
                  <a
                    @click="innerTableStatus(item)"
                    href="javascript:;"
                    class="purchase-btn d-flex align-items-center"
                  >
                    <i
                      class="fa mg-r-10 tx-gray-300"
                      :class="
                        item.innerTableStatus
                          ? 'fa-minus-square'
                          : 'fa-plus-square'
                      "
                    ></i>
                    <div>
                      <div>
                        <span class="mg-r-5 tx-gray-300">{{
                          $t("order.商品种类:")
                        }}</span>
                        <span class="tx-gray-300 mg-r-10">{{
                          item.totalNum || 0
                        }}</span>
                        <span class="mg-r-5 tx-gray-300">{{
                          $t("rm.待生产数量:")
                        }}</span>
                        <span class="tx-gray-300">{{
                          item.totalWaitingNum || 0
                        }}</span>
                      </div>
                      <div>
                        <span class="mg-r-5 tx-gray-300">{{
                          $t("rm.生产中数量:")
                        }}</span>
                        <span class="tx-gray-300 mg-r-10">{{
                          item.totalInProductionNum || 0
                        }}</span>
                        <span class="mg-r-5 tx-gray-300">{{
                          $t("rm.已完成数量:")
                        }}</span>
                        <span class="tx-gray-300">{{
                          item.totalFinishedNum || 0
                        }}</span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <!-- 商品列表 -->
              <div class="pd-l-30 mg-t-5" v-show="item.innerTableStatus">
                <div
                  class="mg-t-5 order-pro bg-sub"
                  v-for="(itemjson, indexjson) in item.itemJson"
                  :key="'a' + indexjson + itemjson.sku"
                >
                  <div
                    :class="{ 'bg-sub2': indexjson % 2 }"
                    class="
                      pos-relative
                      bg-sub1
                      d-flex
                      flex-row
                      align-items-center
                      justify-content-start
                      pos-relative
                    "
                  >
                    <div
                      class="c-8 purchase-img-wrap"
                      style="padding-left: 0 !important"
                    >
                      <div class="media d-block d-sm-flex">
                        <!-- 图片 -->
                        <div class="pos-relative">
                          <a
                            v-if="!errorImg[index + '|' + indexjson]"
                            class="p-img-wrap"
                            href="javascript:;"
                            :data-supplierI="0"
                            :data-orderI="index"
                            :data-skuI="indexjson"
                            v-lazy:background-image="itemjson.skuImage"
                          >
                          </a>
                          <div
                            class="images-arr"
                            v-viewer="{
                              movable: false,
                              zoomable: false,
                              navbar: false,
                            }"
                            @hide="closeViewer"
                            @view="closeViewer"
                            @viewed="
                              showViewer(
                                `sku: ${itemjson.sku},  ${itemjson.skuName}, ${item.code}`
                              )
                            "
                          >
                            <img
                              :src="itemjson.skuImage"
                              :alt="
                                `sku: ${itemjson.sku},  ${itemjson.skuName}, ${item.code}`
                                  | replaceSup
                              "
                            />
                          </div>
                        </div>
                        <!-- 商品信息 -->
                        <div
                          class="
                            media-body
                            align-self-center
                            mg-t-10 mg-b-10
                            title-diy
                          "
                        >
                          <p class="mg-b-5 tx-ellipsis2">
                            {{ itemjson.skuName }}
                          </p>
                          <p class="mg-b-5">
                            <span class="mg-r-5">SKU:</span>
                            <span class="tx-gray-300 mg-r-5">{{
                              itemjson.sku
                            }}</span>
                            <a
                              v-show="itemjson.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="itemjson.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                          <p class="mg-b-5">
                            <span class="mg-r-5">{{ $t("mall.属性：") }}</span>
                            <span class="tx-gray-300 mg-r-5">{{
                              skuTypes[itemjson.skuType]
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="c-4 tx-center">
                      <!-- 订单状态 -->
                      <div class="tx-white">
                        {{
                          (($parent.mStatus || {})[itemjson.status] || {}).name
                        }}
                      </div>
                      <!-- 发货状态 -->
                      <div v-if="itemjson.shipStatus">
                        ({{ shipStatus[itemjson.shipStatus] }})
                      </div>
                    </div>
                    <div class="c-4">
                      <!-- 待生产数量 -->
                      <div>
                        {{ $t("rm.待生产数量：")
                        }}<span class="tx-gray-300">{{
                          itemjson.waitingNum || 0
                        }}</span>
                      </div>
                      <!-- 生产中数量 -->
                      <div>
                        {{ $t("rm.生产中数量：")
                        }}<span class="tx-gray-300">{{
                          itemjson.inProductionNum || 0
                        }}</span>
                      </div>
                      <!-- 已完成数量 -->
                      <div>
                        {{ $t("rm.已完成数量：")
                        }}<span class="tx-gray-300">{{
                          itemjson.finishedNum || 0
                        }}</span>
                      </div>
                    </div>
                    <div class="c-4">
                      <!-- 预计生产时间 -->
                      <div>
                        <span
                          data-toggle="tooltip-primary"
                          data-placement="right"
                          :data-original-title="$t('rm.预计生产时间')"
                          class="tx-white"
                        >
                          <span
                            >{{
                              Math.abs(Number(itemjson.productionDuration))
                            }}
                            {{ $t("order.天") }}</span
                          >
                          <span
                            class="tx-danger"
                            v-if="Number(item.productionDuration) < 0"
                            >{{ $t("rm.（已超时）") }}</span
                          >
                        </span>
                      </div>
                      <!-- 预计完成时间 -->
                      <div>
                        <span
                          data-toggle="tooltip-primary"
                          data-placement="right"
                          :data-original-title="$t('rm.预计完成时间')"
                          class="tx-white"
                          >{{
                            itemjson.expectEndTime
                              ? timeFormat_1(itemjson.expectEndTime)
                              : "---"
                          }}</span
                        >
                      </div>
                      <!-- 实际完成时间 -->
                      <div>
                        <span
                          data-toggle="tooltip-primary"
                          data-placement="right"
                          :data-original-title="$t('rm.实际完成时间')"
                          class="tx-white"
                          >{{
                            itemjson.actualEndTime
                              ? timeFormat_1(itemjson.actualEndTime)
                              : "---"
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="c-4 tx-center">
                      <!-- 开始生产 -->
                      <div v-if="isSysRights('Production.startProduction')">
                        <a
                          @click="deliveryOrder(item, true, indexjson)"
                          v-if="itemjson.status != 3 && itemjson.status != 4"
                          href="javascript:;"
                          class="tx-info tx-12 d-inline-block wd-50p"
                          >{{ $t("rm.开始生产") }}</a
                        >
                      </div>
                      <!-- 生产完成 -->
                      <div v-if="isSysRights('Production.completeProduction')">
                        <a
                          v-if="itemjson.status == 2"
                          class="tx-info tx-12 d-inline-block wd-50p"
                          href="javascript:;"
                          @click="productCompletion(item, true, indexjson)"
                          >{{ $t("rm.生产完成") }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!loading && (items || []).length < 1 && !first_loading"
      class="nodata mg-t-50 mg-b-50 text-center tx-24"
    >
      <i class="menu-item-icon icon ion-ios-cart tx-24"></i>
      {{ $t("rm.没有找到符合条件的生产订单数据") }}
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "first_loading",
    "loading",
    "items",
    "check_arr",
    "errorImg",
    "isHistoryData",
    "isAccordion",
  ],
  data() {
    return {
      shipStatus: {
        1: this.$t("rm.未发货"),
        2: this.$t("order.部分发货"),
        3: this.$t("order.已发货"),
      },
      types: {
        1: this.$t("rm.智能创建"),
        2: this.$t("rm.智能创建"),
        3: this.$t("rm.手动创建"),
      },
      skuTypes: {
        1: this.$t("rm.成品sku"),
        5: this.$t("rm.原料sku"),
        7: this.$t("rm.半成品sku"),
      },
      userInfo: store.get("userInfo"),
      checkArr: [],
    };
  },
  computed: {
    isAll() {
      const items = this.items || [];
      return this.checkArr.length == items.length && items.length > 0
        ? true
        : false;
    },
  },
  watch: {
    check_arr() {
      this.checkArr = this.check_arr;
    },
    checkArr() {
      this.$parent.checkArr = this.checkArr;
    },
    // 展开折叠
    isAccordion: function () {
      this.openInnerFormat();
    },
  },
  filters: {
    // 替换标点符号
    replaceSup(val) {
      let st = "";
      st = val.replace(/\'/g, "‘").replace(/\"/g, "“");
      return st;
    },
  },
  updated() {
    // 开启鼠标移入显示信息
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    // 展开折叠
    openInnerFormat() {
      this.items.forEach((e, i) => {
        this.$set(e, "innerTableStatus", !this.isAccordion);
      });
    },
    // 全选或者全不选
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.code);
        });
      }
    },
    // 格式化日期
    timeFormat_1(val) {
      if (!val || val == "0") return "---";
      return moment.unix(Number(val)).format("YYYY-MM-DD");
    },
    // 显示日志
    openMOrderLog(item) {
      this.$parent.popOrderLog = JSON.parse(this.$parent.popOrderLogDefault);
      this.$parent.popOrderLog.orderLog = item.orderLog;
      $("#modalMLog").modal("show");
    },
    // 飘窗
    popContact(event, item, id, obj) {
      this.$emit("popContact", event, item, id, obj);
    },
    // 打印采料单
    printMaterialOrder(item) {
      const printMaterialTemplate = Number(this.userInfo.printMaterialTemplate);
      switch (printMaterialTemplate) {
        default:
          window.open(
            "/print-manufacture-default.html?id=" + item.id,
            "_blank"
          );
          break;
      }
    },
    // 打印生产单
    printProductionOrder(item) {
      const printProductionTemplate = Number(
        this.userInfo.printProductionTemplate
      );
      switch (printProductionTemplate) {
        default:
          window.open("/print-producton-default.html?id=" + item.id, "_blank");
          break;
      }
    },
    // 开始生产
    deliveryOrder(i, bool, index) {
      this.$emit("deliveryOrder", i, bool, index);
    },
    //生产完成
    productCompletion(i, bool, index) {
      this.$emit("productCompletion", i, bool, index);
    },
    // 关闭生产单
    closeProductionOrder(orderId) {
      this.$parent.loading = true;
      $.api_call("api.Production.cancelProduction", { orderId }, (r) => {
        this.$parent.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("rm.关闭成功"), "success");
          setTimeout(() => {
            this.$parent.getOrder(true);
          }, 1000);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    // 备注
    addOrderRemark(item) {
      this.$parent.orderItem = item;
      $("#modalOrderRemark").modal("show");
    },
    // 显示与隐藏商品列表
    innerTableStatus(item) {
      this.$set(item, "innerTableStatus", !item.innerTableStatus);
    },
    // 显示图片
    showViewer(alts) {
      let alt = alts.replace(/\'/g, "‘").replace(/\"/g, "“");
      this.imgAlt = alt;
      this.imgView.imgWidth = $(
        `img[class="viewer-transition"][alt="${alt}"]`
      ).width();
      this.imgView.imgHeight = $(
        `img[class="viewer-transition"][alt="${alt}"]`
      ).height();
      this.imgView.imgOffset = $(
        `img[class="viewer-transition"][alt="${alt}"]`
      ).offset();
      let imgTop =
        this.imgView.imgOffset.top - document.documentElement.scrollTop;
      // 字体位置
      if (this.$parent.watermarkDio.position == "右下角") {
        $("body").append(
          `<div class='img_w' 
        style='position: fixed;z-index: 10000;display:flex;align-items: flex-end;justify-content: flex-end;'>
        ${this.$parent.watermarkDio.text}
      </div>`
        );
      } else if (this.$parent.watermarkDio.position == "平铺") {
        $("body").append(
          `<div class='img_w' 
        style='position: fixed;overflow:hidden;z-index: 10000;display:flex;align-items: center;justify-content: center;'>
        <div style='text-align: center;transform: rotate(-45deg);white-space: nowrap;'>
        ${this.$parent.watermarkDio.text}<br>
        ${this.$parent.watermarkDio.text}<span style='display:inline-block;height:160px;width:200px'></span>${this.$parent.watermarkDio.text}<br>
        ${this.$parent.watermarkDio.text}<span style='display:inline-block;height:160px;width:250px'></span>${this.$parent.watermarkDio.text}<span style='display:inline-block;height:160px;width:250px'></span>${this.$parent.watermarkDio.text}<br>
        ${this.$parent.watermarkDio.text}<span style='display:inline-block;height:160px;width:200px'></span>${this.$parent.watermarkDio.text}<br>
        <span style='display:inline-block;height:160px'></span>${this.$parent.watermarkDio.text}<br>
        </div>
      </div>`
        );
      } else if (this.$parent.watermarkDio.position == "中间") {
        $("body").append(
          `<div class='img_w' 
        style='position: fixed;z-index: 10000;display:flex;align-items: center;justify-content: center;'>
        ${this.$parent.watermarkDio.text}
      </div>`
        );
      }
      $(".img_w").css("width", this.imgView.imgWidth);
      $(".img_w").css("height", this.imgView.imgHeight);
      $(".img_w").css("top", imgTop);
      $(".img_w").css("left", this.imgView.imgOffset.left);

      // 字体大小
      if (this.$parent.watermarkDio.size == "大") {
        $(".img_w").css("font-size", "48px");
      } else if (this.$parent.watermarkDio.size == "中") {
        $(".img_w").css("font-size", "32px");
      } else if (this.$parent.watermarkDio.size == "小") {
        $(".img_w").css("font-size", "16px");
      }
      // 字体颜色
      if (this.$parent.watermarkDio.color == "白") {
        $(".img_w").css("color", "rgba(255,255,255,.7)");
      } else if (this.$parent.watermarkDio.color == "灰") {
        $(".img_w").css("color", "rgba(128,128,128,.7)");
      } else if (this.$parent.watermarkDio.color == "黑") {
        $(".img_w").css("color", "rgba(0,0,0,.7)");
      }
    },
    // 关闭图片
    closeViewer() {
      $(".img_w").remove();
    },
  },
};
</script>

<style scoped="scoped">
.title-diy {
  flex-direction: column;
}
.title-diy .label {
  display: flex;
}
.title-diy .label p {
  padding: 2px 4px;
  border: 1px solid #343a40;
  margin-right: 5px;
  color: #343a40;
}
/* 图片蒙版样式 */
.img_w {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* z-index: 10000; */
  color: #000;
}
.purchase-img-wrap .pos-relative {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}
.purchase-img-wrap .pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  transform: scale(0.9, 0.9);
}
.purchase-img-wrap .pos-relative .mult-img-bg {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 80px;
  height: 80px;
  transform: scale(0.9);
  background: #666;
  border: 1px solid #333;
}
.white-body .purchase-img-wrap .pos-relative .mult-img-bg {
  background: #e6e6e6;
}
.purchase-img-wrap .pos-relative .num {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  background-color: #1caf9a;
  color: #fff;
  padding: 0 3px;
  height: 18px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
}
a.log:hover {
  color: #868e96;
}
.modal-loading {
  position: relative;
  background: transparent;
}
.scm-loader {
  width: 80px;
  height: 80px;
  position: relative;
  top: 0;
  left: 0;
  -webkit-transform: translate(0);
  transform: translate(0);
  margin: 0 auto;
}
.shippingfee-confirm > .popover {
  display: none;
}
.shippingfee-confirm.hoverBg > .popover {
  display: block;
}
.delivertime-wrap {
  position: relative;
  border: 1px dashed #868e96;
  margin: 10px 0;
  border-radius: 3px;
  padding: 10px 5px 5px;
  display: inline-block;
  min-width: 51%;
}
.delivertime-wrap > span.bg-warning {
  position: absolute;
  right: -10px;
  top: -7px;
  border-radius: 1px;
  padding: 0 5px;
  font-size: 12px;
  background-color: #f27510 !important;
}
body.white-body .delivertime-wrap > span.bg-warning {
  color: #fff !important;
}
caption {
  padding: 10px 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: none;
  /*  background: #343a40 !important;*/
  /*	background: rgba(0,0,0,.3);*/
  /*	background: rgba(68,88,112,1);*/
  background: #223043;
}
.purchase-order-table {
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 20px;
}
.show-white-style caption {
  border: none;
  background: #dee2e6 !important;
}
.show-white-style .card .order-pro {
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.card .order-pro {
  background-color: #1a2432;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.card .order-pro.abnormal-pro {
  border: 1px solid #dc3545;
}
.triangle {
  position: absolute;
  left: -26px;
  top: -26px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border: 30px solid transparent;
  border-right-color: #dc3545;
  z-index: 2;
}
.title {
  position: absolute;
  left: 6px;
  top: 9px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  font-size: 12px;
  color: #fff;
  z-index: 3;
}
.c-1,
.c-2,
.c-3,
.c-4,
.c-5,
.c-6,
.c-7,
.c-8,
.c-9,
.c-10,
.c-11,
.c-12,
.c-13,
.c-14,
.c-15,
.c-16,
.c-17,
.c-18,
.c-19,
.c-20,
.c-21,
.c-22,
.c-23,
.c-24 {
  padding-right: 0;
  padding-left: 0;
}
.supplier-wrap {
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0;
  background: none;
}
.show-white-style .supplier-wrap {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0;
  background: rgba(255, 255, 255, 0.4);
}
.list-heard-supplier {
  padding: 10px;
  margin: 0;
  background: #223043;
}
.show-white-style .list-heard-supplier {
  padding: 10px;
  margin: 0;
  background: #dee2e6 !important;
}
.bg-sub .bg-sub1 {
  overflow: hidden;
}
.bg-sub .bg-sub1 {
  background-color: rgba(0, 0, 0, 0.4);
}
.bg-sub .bg-sub1.bg-sub2 {
  background-color: rgba(0, 0, 0, 0.2);
}
.show-white-style .bg-sub .bg-sub1 {
  background-color: #e6e6e6;
}
.show-white-style .bg-sub .bg-sub1.bg-sub2 {
  background-color: #f6f6f6;
}
.flag {
  position: absolute; /*绝对定位*/
  height: 20px;
  line-height: 20px;
  text-align: center;
  width: 74px;
  /*  background-color: #868ba1;*/
  color: #fff;
  z-index: 2;
}
.flag-left {
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  right: -18px;
  top: 9px;
}
.abnormal-itemjson {
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(220, 50, 70, 0.3)
  );
  height: 80px;
}
.abnormal-itemjson .tx-danger {
  font-weight: bold;
}
</style>
<style>
.purchase-order-table .pagination,
.list-wrap .pagination {
  justify-content: center !important;
}
.order-type {
  padding: 2px 8px;
  color: #fff;
  border-radius: 3px;
}
.show-white-style .order-type span.tx-white {
  color: #fff !important;
}
</style>